<template>

  <div class="flex flex-col gap-1 relative my-4">
    <select id="shop_identifier"
            v-model="selectedPoint"
            :disabled="inProgress"
            name="shop_identifier"
            @change="onSelectShop"
            class="w-full h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all focus-within:border-lime-green hover:border-lime-green border-light-gray/25 cursor-pointer"
    >
      <option :value="null" disabled selected>{{ in18['attribute_shipping_shop_option'] }}</option>
      <option v-for="(point, index) in points"
              :key="index"
              :value="point">
            {{ point.full_address }}
      </option>
    </select>
    <span v-if="errors['shipping.identifier']" class=" text-[12px] text-[#eb2635] text-left">*{{ errors['shipping.identifier']?.[0]}}</span>
  </div>

  <div class="flex flex-col gap-1 relative overflow-hidden">
    <label class=" leading-[14px] font-light absolute left-[17px] transition-all pointer-events-none" :class="[shipping.message ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']" for="shop_message">
      {{ in18['attribute_shipping_message_option'] }}
    </label>
    <textarea
        id="shop_message"
        v-model="shipping.message"
        :class="[errors['shipping.message'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', shipping.message ? 'pt-[30px]' : 'pt-[16px]' ]"
        :disabled="inProgress"
        class="min-h-[100px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all"
        name="shop_message"
    />
    <span v-if="errors['shipping.message']?.length" class=" text-[12px] text-[#eb2635] text-left">*{{ errors['shipping.message']?.[0]}}</span>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import axios from 'axios';

// Define props
const props = defineProps({
  shippingMethod: {
    type: Object,
    required: true,
  },
  shipping: {
    type: Object,
    required: true,
  },
  errors: {
    type: Object,
    required: true,
  },
  in18: {
    type: Object,
  },
  inProgress: {
    type: Boolean,
  },
  addresses: {
    type: Array,
  }
});

// Define emits
const emit = defineEmits([
  'update-cart',
  'country-selected',
  'update-in-progress',
  'update-error',
  'update-shipping-address',
]);

// Reactive state variables
const points = ref([]);
const selectedPoint = ref(null);
const selectedShippingAddress = ref(null);

// Fetch available points
function getAvailablePoints() {
  axios
    .get(`/api/shipping/${props.shippingMethod.id}/pickup-points`, {
      params: {
        country_id: props.shipping.country_id,
      },
    })
    .then((response) => {
      points.value = response.data.points;
      selectedPoint.value = response.data.points[0];
      onSelectShop();
    })
    .catch((error) => {
      console.error('Error fetching pickup points:', error);
    });
}

// Update shipping data when a shop is selected
function onSelectShop() {
  if (selectedPoint.value) {
    props.shipping.identifier = selectedPoint.value.identifier;
    props.shipping.country_id = selectedPoint.value.country_id;
    props.shipping.zip = selectedPoint.value.zip;
    props.shipping.city = selectedPoint.value.city;
    props.shipping.address = selectedPoint.value.address;
  }
}

// Fetch available points when the component is created
getAvailablePoints();

// Watch for changes in the shipping country and fetch points accordingly
watch(
  () => props.shipping.country_id,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      getAvailablePoints();
    }
  }
);
</script>


<style>
select#shop_identifier {
  padding-right: 2rem; /* Adjust to match text padding */
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23333' d='M5 6L0 0h10L5 6z'/%3E%3C/svg%3E"); /* Smaller arrow icon */
  background-position: right 16px center;
  background-repeat: no-repeat;
}

</style>